import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type {
  Assignee,
  InstitutionMember,
} from '@backrs_ui/grow-ui/src/redux/coachingDashboard/coachingDashboard.types';

export const useAgentContext = (member: Assignee | InstitutionMember | undefined) => {
  useRegisterAgentContext(
    member
      ? {
          kind: 'section',
          title: 'Are You On Track?',
          description:
            'The Are You On Track result on screen belongs to the student this page names, not to the signed-in coach. The timeline, the track it reports and the assessment breakdown all describe that student, and the target track is the one their own Blueprint set.',
        }
      : null,
  );
};
